export const DashboardSharingType = {
  Custom: 'custom',
  Organisation: 'organisation',
  UserOnly: 'user_only',
} as const;

export type DashboardSharingType =
  (typeof DashboardSharingType)[keyof typeof DashboardSharingType];
